
import { useAssessmentsStore } from '@entities/assessment'
import { useKidRoutes } from '@entities/customer'
import { WsEvent } from '@shared/api'
import { useKidStore } from '@entities/customer'
import { useActiveKidDisciplinesApi } from '@entities/customer'
import { onDisciplineReady } from '@entities/customer'

export const useListenEventAssessment = (channel: any): void => {
  const assessmentsStore = useAssessmentsStore()
  const kidStore = useKidStore()

  const { isRouteHome } = useKidRoutes()

  onDisciplineReady(() => {
    if (isRouteHome.value) {
      channel.listen(WsEvent.AssessmentCreated, async (): Promise<void> => {
        if (kidStore.activeKidId !== null) void useActiveKidDisciplinesApi(kidStore.activeKidId)
        assessmentsStore.refreshNow()
      })
    }
  })
}
